export const parseQuery = (query: any) =>
  query
    .substring(1)
    .split('&')
    .map((str: any) => {
      const [key, value] = str.split('=');
      return { [key]: decodeURI(value) };
    })
    .reduce((prev: any, curr: any) => Object.assign(prev, curr));
